import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';

import { MysqlService } from './../../../../services/mysql.service';
import { SubjectNote } from './../../../../api/subjectNote';
import {DemoService} from '../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { GlobalFunctionsService } from './../../../../services/global-functions.service';

import {SubjectNotes} from './../../../../shared/models/subjectNotes.model';
import { JobSubject } from './../../../../shared/models/jobSubject.model';
import { HotToastService } from '@ngneat/hot-toast';


@Component({
  selector: 'app-subject-notes-list',
  templateUrl: './subject-notes-list.component.html',
  styleUrls: ['./subject-notes-list.component.css']
})
export class SubjectNotesListComponent implements OnInit {

  model: any;

  @Input() subject_id: number;
  @Input() job_id: any;
  @Input() file_number: number;
    brand_id: number;

  @Input() current_model: any;
  @Input() button_type: any;

  currentUserVAR: any;
  sessionUserId: number;
  sessionUsername: any;
  sessionBrandId: number;
  
  subject_notes: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  get_latest_subject_note_id: Object;
  subjects: any = JobSubject;
  sessionUserLevel: number;
  brand_types: any;
  base_route: string;
  current_base_route: any;
  all_router_details: string;

  allRecipients = []; // collection of subjects as note recipients 
  assigned_to_agents_array = []; // collection of subjects as note recipients 
  assignedAgentsList: Object;
  job: Object;
  subject: any;


   // Text editor Settings
 public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo',
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
}; 

  constructor(private route: ActivatedRoute, public router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    public gfunc: GlobalFunctionsService,
    public toastr: HotToastService,
    ) {


// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

      this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));

// may beed to comment out to work as module. 
// this.toastr.setRootViewContainerRef(vcr);
   }



  ngOnInit() {
   this.model = new SubjectNote();

   this.model.note_content = '';

   if(this.job_id >= 1){
   this.getJob(this.job_id);
   }
    // this.getSubjectNotes(this.subject_id);
   
   // this.getSubjectNotesProgression(this.job_id, this.file_number);
   if (this.subject_id >= 1) {
    console.log('Subject Detected: ' + this.subject_id);
   this.getJobSubject(this.subject_id);
   this.getSubjectAgentBrandsAssigned(this.subject_id); // load the agents to array ready for agent note
   }
   this.getBrandTypes();
  }

  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        // Need to load the drop downs (only if a process is selected.)

        // this.model.subject_number = res.subject_number;
        // this.model.job_reference_number = res.job_reference_number;
        // this.model.file_number = res.file_number;
        // this.model.reference_number = res.reference_number;
        
      
        this.model.brand_id = res.brand_report_id;
        this.model.brand_brand_id = res.brand_report_id;
        this.model.brand_invoice_id = res.brand_invoice_id;

        this.model.job_status_code = res.job_status_code;

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      data => { this.subject_notes = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
 

      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }



    getSubjectNotesProgression(job_id, file_number) {
      this._demoService.getSubjectNotesProgression(job_id, file_number).subscribe(
        data => { this.subject_notes = data;
         // console.log("Done loadng USER");
         // console.log(this.users);
   
  
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }


    
 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}



// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table

       // if an agent posting
       if(this.gfunc.sessionUserLevel === 5) {
       this.RemoveElementOthersFromAllRecipients(this.gfunc.sessionBrandId);
       };


       this.model.assigned_to_agents = JSON.stringify(this.allRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 RemoveElementFromAllRecipients(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



// :: Method to all default recipients
setAllRecipients(model) {
  this.allRecipients = [];

if (model.send_to_report == 1) {
  // 
        // :: Impliments automatic recipients based on chosen com template options
        // :: Subract Method / Filter
        // :: DEMOSERVICE look up client brand details.
        this._demoService.getBrandById(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Client Report',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Client Report',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          // () => console.log('Client Report Recipient Added.')
        );

    } // end if send_to_report
      
    // AGENT
    if ( model.brand_type_id == 3) { 
      this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
             recipient_name: res.name + ' - Agent',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Agent',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.

        },
        (err) => console.error(err),
        // () => console.log('Agent Recipients Added.')
      );
      // const key = 'Agent';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Agent Recipients');
      //   }
      // });
    };

    if (model.send_to_report_user == 1) {

      this._demoService.getUsersById(model.brand_report_user_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
          recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
          recipient_email_address: res.email_address,
          recipient_brand_id: null,
          recipient_brand_type_id: null,
          recipient_user_id: res.user_id,
          recipient_user_level_id: res.access_level,
          recipient_type_name: 'Client Report User',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.

        },
        (err) => console.error(err),
        // () => console.log('Client Report User Recipient Added.')
      );
      // const key = 'Client Report User';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Report User Recipient');
      //   }
      // });
    };

    if (model.send_to_invoice == 1) {
        this._demoService.getBrandById(model.brand_invoice_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Client Accounts',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Client Accounts',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          // () => console.log('Client Accounts Recipient Added.')
        );
    }

    if (model.send_to_logins == 1) {
      this._demoService.getBrandUsers(model.brand_report_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
          recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
          recipient_email_address: res.email_address,
          recipient_brand_id: null,
          recipient_brand_type_id: null,
          recipient_user_id: res.user_id,
          recipient_user_level_id: res.access_level,
          recipient_type_name: 'Client User',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.

        },
        (err) => console.error(err),
        // () => console.log('Client User Recipient Added.')
      );
      // const key = 'Client User';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Client User Recipients');
      //   }
      // });
    }

    if (model.send_to_primary == 1) {
      this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
           this.allRecipients.push({
          recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
          recipient_email_address: res.email_address,
          recipient_brand_id: null,
          recipient_brand_type_id: null,
          recipient_user_id: res.user_id,
          recipient_user_level_id: res.access_level,
          recipient_type_name: 'Client Primary Contact',
           });
           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.


        },
        (err) => console.error(err),
        // () => console.log('Client Primary Contact Added.')
      );
     
     
      // const key = 'Primary Contact';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Primary Contact Recipient');
      //   }
      // });
    }

} // end function









createSubjectNote(model) {
  this.model.subject_id = this.subject_id;
  this.model.job_id = this.job_id;
  this.model.created_by = this.gfunc.sessionUserId;
  this.getJobSubject(this.subject_id);
  this.model.note_type_id = 2;
  this.model.user_level_id = this.gfunc.sessionUserLevel;
  
  if(this.gfunc.sessionUserLevel >= 5) { // agents and above cannot choose
  this.model.brand_type_id = this.gfunc.sessionBrandTypeId;
  model.brand_type_id = this.gfunc.sessionBrandTypeId;
  }else {

  }

  model.subject_com_type_id = null;
  model.subject_template_doc_id = null;
  model.file_id = null;
 model.user_level_id = this.gfunc.sessionUserLevel;
  
  // this.gfunc.insertLog_CreateJobNote(model);
// :: System works but need to upgrade to be part of new communication system wiched emails  off.
// this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);

  this._demoService.createSubjectNote(model).subscribe(
       data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
        // this.getTraceCandidateNotes(this.trace_candidate_id);

       // CreateJob3Component.getTraceCandidateNotes();

       // CreateJob3Component.returned.next(false);
        // this.toastr.info('Note Added To Subject!');
        // this.getSubjectNotes(this.subject_id);
     //   this.getSubjectNotesProgression(this.job_id, this.file_number);
      
     this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
     this.router.navigate(['admin/jobs/subject/edit/' + this.subject_id + '']));

         //  return true;
       },
       error => {
         // console.log(Observable.throw(error));
         // return Observable.throw(error);
         // seems to erorr  but sends informatio nto DB correctly
         this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
         this.router.navigate(['admin/jobs/subject/edit/' + this.subject_id + '']));
       }
  );
  }


  clientCreateSubjectNote(model) {
    this.model.subject_id = this.subject_id;
    this.model.job_id = this.job_id;
    this.model.created_by = this.gfunc.sessionUserId;
    this.getJobSubject(this.subject_id);
    this.model.note_type_id = 2; // is note added.
    this.model.user_level_id = this.gfunc.sessionUserLevel;
   this.model.brand_type_id = this.gfunc.sessionBrandTypeId;
  
   model.subject_com_type_id = null;
   model.subject_template_doc_id = null;
   model.file_id = null;
   model.brand_type_id = this.gfunc.sessionBrandTypeId; // should work for both agent and client
  model.user_level_id = this.gfunc.sessionUserLevel;
   model.brand_id = this.gfunc.sessionBrandId;

     // Fix for agent notes not loading correctly when not allocated to agent on all cards.
     if(model.assigned_to_agents == null){
      model.assigned_to_agents = '[]';
     }

   // agemt security: if agent creating then remove other agents from array first
   if(this.gfunc.sessionUserLevel == 5) {
    this.RemoveElementOthersFromAllRecipients(this.gfunc.sessionBrandId); // adds the logged in agent only.

    // we also need to update the Subject Status
            if(this.gfunc.sessionUserLevel == 5){
              console.log('Subject_ID: ' + this.subject_id)
              model.subject_id = this.subject_id;
              // this.updateSubjectStatus(model, "UPDRECEIVED");
              this.updateSubjectStatus(model, "UPDREC");
            }
    }

    // new status
    if(this.gfunc.sessionUserLevel == 9){
      console.log('Subject_ID: ' + this.subject_id)
      model.subject_id = this.subject_id;
      // this.updateSubjectStatus(model, "UPDRECEIVED");
        // change subject status - UPDATE REC UPDREC
      // this.updateSubjectStatus(model, 'NOTEREC')  /// Removed hard Coded to update subject status 14/3/2026
    }

          // set for notice and log
          let subject_name = this.subject[0].first_name + '' + this.subject[0].surname;
          let subject_business_name = this.subject[0].business_name;
          
                  if(subject_business_name != '') {
                        subject_name = subject_business_name;
                    }
            model.subject_name = subject_name;

// combine the two models notes and subject.
    model = {
...this.subject, // sent through @inputs to the notes list creation from the subject card
...model,
subject_name: model.subject_name
    };

this.gfunc.insertLog_CreateSubjectNote(model);
  // :: System works but need to upgrade to be part of new communication system wiched emails  off.
  // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);



  // basic model adds new fileds
    this._demoService.createSubjectNoteBasic(model).subscribe(
         data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
         // CreateJob3Component.returned.next(false);
          // this.toastr.info('Note Added To Subject!');



          this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

          //  return true;
         },
         error => {
           // console.log(Observable.throw(error));
           // return Observable.throw(error);
           // seems to erorr  but sends informatio nto DB correctly
           this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
         }
    );
    }



    
    updateJobJobStatus(model, status){
      model.job_id = this.job_id;
  
      model.job_status = status;
  
      this._demoService.updateJobJobStatus(model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the list
         // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        // this.toastr.success('Job Status Updated');

    this.gfunc.insertLog_UpdateJob(model);

   //     this.gfunc.insertLog_UpdateSubjectStatus(model);
        // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     //   this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
        },
        error => {
         // console.error('Error saving Event!');
          // this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
       // err => console.error(err),
       // () => console.log('done updates')
    );}

    updateSubjectStatus(model, status){
      model.job_id = this.job_id;
  
      model.job_status = status;
  
      this._demoService.updateSubjectStatus(model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the list
         // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        this.toastr.success('Subject Status Updated');

    this.gfunc.insertLog_UpdateSubjectStatus(model);

   //     this.gfunc.insertLog_UpdateSubjectStatus(model);
        // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     //   this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
        },
        error => {
         // console.error('Error saving Event!');
          // this.toastr.error('Error Changing Status of Subject');
         return console.log(error);
        }
       // err => console.error(err),
       // () => console.log('done updates')
    );}




    RemoveElementOthersFromAllRecipients(key: number) {
      // test! -- load again an then filter and create the array again.
      // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.
    
      // delay load slightly so I can refresh the allRecpientList first.
      setTimeout(function() {   
    }, 2000);
        // console.log("Ready to clean array!")
    
      let array = this.allRecipients;
      // removes all not matching
        // :: Specifcally removes the array item without there being
        // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
        this.allRecipients.forEach((value, index) => {
        if (value.recipient_brand_id !== key) {
          this.allRecipients.splice(index, 1);
        }
      }
      );
      // console.log('Recipients after Removal Others: ', JSON.stringify(this.allRecipients));
    
    // ::@https://stackoverflow.com/questions/5310304/remove-json-element
    // let json = this.allRecipients
    // let id_key = "recipient_brand_id";
    // delete json[id_key]; // Removes json.foo from the dictionary.
    
    this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
    
    };



    clientCreateJobNote(model) {
      this.model.subject_id = null;
      this.model.job_id = this.job_id;
      this.model.created_by = this.gfunc.sessionUserId;
      // this.getJobSubject(this.subject_id);
      this.model.note_type_id = 2; // is note added.
      this.model.user_level_id = this.gfunc.sessionUserLevel;
     // this.model.brand_type_id = 2;
     model.file_number = this.file_number; // was missing so that it can appear in step two of client notes.

     model.subject_com_type_id = null;
     model.subject_template_doc_id = null;
     model.file_id = null;
     model.brand_type_id = 2;
    model.user_level_id = this.gfunc.sessionUserLevel;
     model.brand_id = this.gfunc.sessionBrandId;

     // Fix for agent notes not loading correctly when not allocated to agent on all cards.
     if(model.assigned_to_agents == null){
      model.assigned_to_agents = '[]';
     }

    // new status
    if(this.gfunc.sessionUserLevel == 9){
     
      // this.updateSubjectStatus(model, "UPDRECEIVED");
        // change subject status - UPDATE REC UPDREC
      this.updateJobJobStatus(model, 'NOTEREC')
    }


     this.gfunc.insertLog_CreateJobNote(model);
    // :: System works but need to upgrade to be part of new communication system wiched emails  off.
    // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);

    // basic model adds new fileds
      this._demoService.createSubjectNoteBasic(model).subscribe(
           data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
           // CreateJob3Component.returned.next(false);
            // this.toastr.info('Note Added To Job!');
            

                      // redirect 
          if(model.job_id >= 0) {
            this.gfunc.globalJobViewSkipRoute(this.job_id);
            }else{
              this.gfunc.globalJobsView();
            }
            
            //  return true;
           },
           error => {
             // console.log(Observable.throw(error));
             // return Observable.throw(error);
             // seems to erorr  but sends informatio nto DB correctly
                          // redirect 
          if(model.job_id >= 0) {
            this.gfunc.globalJobViewSkipRoute(this.job_id);
            }else{
              this.gfunc.globalJobsView();
            }
           }
      );
      }
  


      clientCreateJobNoteWizard(model) {
        this.model.subject_id = null;
        this.model.job_id = this.job_id;
        this.model.created_by = this.gfunc.sessionUserId;
        // this.getJobSubject(this.subject_id);
        this.model.note_type_id = 2; // is note added.
        this.model.user_level_id = this.gfunc.sessionUserLevel;
       // this.model.brand_type_id = 2;
    
       model.file_number = 1; // was missing so that it can appear in step two of client notes.

       model.subject_com_type_id = null;
       model.subject_template_doc_id = null;
       model.file_id = null;
       model.brand_type_id = 2;
      model.user_level_id = this.gfunc.sessionUserLevel;
       model.brand_id = this.gfunc.sessionBrandId;

            // Fix for agent notes not loading correctly when not allocated to agent on all cards.
     if(model.assigned_to_agents == null){
      model.assigned_to_agents = '[]';
     }
  

    // new status -- so that when adding a note in the draft mode status does not change.... on the route.
    if(this.gfunc.sessionUserLevel == 9 && this.gfunc.current_base_route != '/client/jobs/create-job-wizard-step-3'){
      // this.updateSubjectStatus(model, "UPDRECEIVED");
        // change subject status - UPDATE REC UPDREC
      this.updateJobJobStatus(model, 'NOTEREC')
    }

      //  this.gfunc.insertLog_CreateJobNote(model);
    
 
  if(this.gfunc.current_base_route == '/client/jobs/create-job-wizard-step-3'){
 this.gfunc.insertLog_CreateSubjectNoteMYDRAFT(model) // NEED NEW TRIGGER SO THAT IT RUNS WHEN A DRAFT NOTE RECIEVED.....
  }else{
   this.gfunc.insertLog_CreateSubjectNote(model); 
  }


      // :: System works but need to upgrade to be part of new communication system wiched emails  off.
      // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
  
      // basic model adds new fileds
        this._demoService.createSubjectNoteBasic(model).subscribe(
             data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
             // CreateJob3Component.returned.next(false);
              this.toastr.success('Note Added To Job!');
              
  
                        // redirect 
            // if(model.job_id >= 0) {
            //   this.gfunc.globalJobViewSkipRoute(this.job_id);
            //   }else{
            //     this.gfunc.globalJobsView();
            //   }
              
             return true;
              },
             error => {
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
               // seems to erorr  but sends informatio nto DB correctly
                            // redirect 
            // if(model.job_id >= 0) {
            //   this.gfunc.globalJobViewSkipRoute(this.job_id);
            //   }else{
            //     this.gfunc.globalJobsView();
            //   }
             }
        );
       }
    

      staffCreateJobNote(model) {
        this.model.subject_id = null;
        this.model.job_id = this.job_id;
        this.model.created_by = this.gfunc.sessionUserId;
        // this.getJobSubject(this.subject_id);
        this.model.note_type_id = 2; // is note added.
        this.model.user_level_id = this.gfunc.sessionUserLevel;
       // this.model.brand_type_id = 2;
  
       model.subject_com_type_id = null;
       model.subject_template_doc_id = null;
       model.file_id = null;
      // model.brand_type_id = this.model.brand_type_id; // get from form drop down
      model.user_level_id = this.gfunc.sessionUserLevel;

       // for brand
       if (model.brand_type_id == 2){
       model.brand_id = this.model.brand_id; // loaded from getjobSuvhet above 
       //  model.brand_id = this.gfunc.sessionBrandId; 
    }
    if (model.brand_type_id == 1){
      model.brand_id = this.gfunc.sessionBrandId; //
      //  model.brand_id = this.gfunc.sessionBrandId;
   }

   this.gfunc.insertLog_CreateJobNote(model);
      // :: System works but need to upgrade to be part of new communication system wiched emails  off.
      // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
  
      // basic model adds new fileds
        this._demoService.createSubjectNoteBasic(model).subscribe(
             data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
             // CreateJob3Component.returned.next(false);
              // this.toastr.info('Note Added To Job!');

                        // redirect 
            if (model.job_id >= 0 && this.gfunc.current_base_route === '/admin/jobs/create-job-3/' ) {
              this.gfunc.globalJobEditStep3(this.job_id); // job edit
              }else if (model.job_id >= 0 ) {
                this.gfunc.globalJobViewSkipRoute(this.job_id); // job view
              }else {
                this.gfunc.globalJobsView(); // job view
              }
              
              //  return true;
             },
             error => {
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
               // seems to erorr  but sends informatio nto DB correctly
                                 // redirect 
                                 if (model.job_id >= 0 && this.gfunc.current_base_route === '/admin/jobs/create-job-3/' ) {
                                  this.gfunc.globalJobEditStep3(this.job_id); // job edit
                                  }else if (model.job_id >= 0 ) {
                                    this.gfunc.globalJobViewSkipRoute(this.job_id); // job view
                                  }else {
                                    this.gfunc.globalJobsView(); // job view
                                  }
             }
        );
        }


        staffCreateSubjectNote(model) {
          this.model.subject_id = this.subject_id;
          this.model.job_id = this.job_id;
          this.model.created_by = this.gfunc.sessionUserId;
          this.getJobSubject(this.subject_id);
          this.model.note_type_id = 2; // is note added.
          this.model.user_level_id = this.gfunc.sessionUserLevel;
        // this.model.brand_type_id = this.gfunc.sessionBrandTypeId;
        
         model.subject_com_type_id = null;
         model.subject_template_doc_id = null;
         model.file_id = null;
       //  model.brand_type_id = 2;
        model.user_level_id = this.gfunc.sessionUserLevel;
        
         // change default to brand_report_id
        // set when getting subject qwuery oninit.

              // for brand
              if (model.brand_type_id == 2){
                model.brand_id = this.model.brand_id; // loaded from getjobSuvhet above 
                //  model.brand_id = this.gfunc.sessionBrandId; 
             }
             if (model.brand_type_id == 1){
               model.brand_id = this.gfunc.sessionBrandId; //
               //  model.brand_id = this.gfunc.sessionBrandId;
            }
      
         this.gfunc.insertLog_CreateSubjectNote(model); // this had the wrong log as of performance activity reproting.
        // :: System works but need to upgrade to be part of new communication system wiched emails  off.
        // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
        
        // basic model adds new fileds
          this._demoService.createSubjectNoteBasic(model).subscribe(
               data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
               // CreateJob3Component.returned.next(false);
                // this.toastr.info('Note Added To Subject!');
                // this.gfunc.insertLog_CreateJobNote(model);
      
                this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
      
                //  return true;
               },
               error => {
                 // console.log(Observable.throw(error));
                 // return Observable.throw(error);
                 // seems to erorr  but sends informatio nto DB correctly
                 this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
               }
          );
          }


      agentCreateJobNote(model) {
        this.model.subject_id = null;
        this.model.job_id = this.job_id;
        this.model.created_by = this.gfunc.sessionUserId;
        this.getJobSubject(this.subject_id);
        this.model.note_type_id = 2; // is note added.
        this.model.user_level_id = this.gfunc.sessionUserLevel;

       model.subject_com_type_id = null;
       model.subject_template_doc_id = null;
       model.file_id = null;
       model.brand_type_id = this.gfunc.sessionBrandTypeId;
       model.user_level_id = this.gfunc.sessionUserLevel;
       model.brand_id = this.gfunc.sessionBrandId;
    
           // agemt security: if agent creating then remove other agents from array first
   if(this.gfunc.sessionUserLevel == 5) {
    this.RemoveElementOthersFromAllRecipients(this.gfunc.sessionBrandId); // adds the logged in agent only.
    }


    this.gfunc.insertLog_CreateJobNote(model);
      // :: System works but need to upgrade to be part of new communication system wiched emails  off.
      // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
      
      // basic model adds new fileds
        this._demoService.createSubjectNoteBasic(model).subscribe(
             data => {  this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
             // CreateJob3Component.returned.next(false);
              // this.toastr.info('Note Added To Job!');
  
                        // redirect 
            if(model.job_id >= 0) {
              this.gfunc.globalJobViewSkipRoute(this.job_id);
              }else{
                this.gfunc.globalJobsView();
              }
              
              //  return true;
             },
             error => {
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
               // seems to erorr  but sends informatio nto DB correctly
                            // redirect 
            if(model.job_id >= 0) {
              this.gfunc.globalJobViewSkipRoute(this.job_id);
              }else{
                this.gfunc.globalJobsView();
              }
             }
        );
        }

  
  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subject = data;
        let res = data[0];
        this.model.subject_number = res.subject_number;
        this.model.job_reference_number = res.job_reference_number;
        this.model.file_number = res.file_number;
        this.model.reference_number = res.reference_number;
        this.model.brand_id = res.brand_report_id;
        this.model.brand_brand_id = res.brand_report_id;
        this.model.brand_invoice_id = res.brand_invoice_id;
        
        // console.log('subject: ' + JSON.stringify(res));
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  deleteSubjectNote(note_id) {
    if (confirm('Are you sure you want to delete this note? ')) {
      this._demoService.deleteSubjectNote(note_id).subscribe(
         data => {
          // this.getSubjectNotes(this.subject_id);
          this.getSubjectNotesProgression(this.job_id, this.file_number);
           return true;
         },
         error => {
          //  console.error('Error deleting Trace Candidate Note!');
          return console.log(error);
         }
      );
  }
  }



  sendEmail(job_id, subject_id, user_id, model) {
    this._mysqlService.sendEmail(job_id, subject_id, user_id, model);
      // this.toastr.info('Email Notification Sent to Sharmans!');
    };




    getBrandTypes() {
      this._demoService.getBrandBrandTypes().subscribe(
         data => { this.brand_types = data; },
         err => console.error(err),
        //  // () => console.log('done loading candidate for update')
       );
     }

}
